import React from 'react';
import NavigationBar from './navigation/NavigationBar';
import './LayoutWrapper.css'
import SideMenu from './sideMenu/SideMenu';
import { SideMenuContext } from './sideMenu/SideMenuContext';
import NotificationContainer from '../notification/NotificationContainer';
import { Link } from 'react-router-dom';

//import footerImage  from '../../../assets/images/strawberry-juice-image.png';
//import { useMobileDetect } from '../pages/HomePage';
// Navigation Layout is a HOC for pages
// that will require navigation views to be present.
const LayoutWrapper = (PageComponent, options = {}) => (props) => {

    return (<SideMenuContext>
        {/*<NotificationsWrapper>*/}
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            {options.showNavigationBar && <NavigationBar showSideMenuButton={options.showSideMenu} />}
            {/* Notification Container */}
            <NotificationContainer />

            <div background={options.backgroundImage} className={`centered-view ${options.showSideMenu ? 'offset-centered-view' : ''}`} style={{
                backgroundColor: options.backgroundColor,
                backgroundImage: `url(${options.backgroundImage})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                flexGrow: 1,
                minHeight: 'auto',
                flexDirection: 'column',
                alignItems: `${options.alignCenter ? 'center' : 'flex-start'}`,
                justifyContent: `${options.alignCenter ? 'center' : 'start'}`
            }}>


                {/*Page Component*/}
                <PageComponent {...props} />

                {/*Side Menu*/}
                {options.showSideMenu === true && <SideMenu />}
            </div>
            <div style={{ background: '#b800f7', position: 'relative', color: 'white', width: '100%', flexDirection: 'column', alignItems: 'center', padding: 10, minHeight: 50, display: 'flex' }}>
                <div style={{ display: 'flex', padding: 10, justifyContent: 'space-evenly', width: '100%', fontSize: 10, lineHeight: 1.5 }}>

                    <div style={{
                        height: 100,
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        width: 100,
                        backgroundColor: '#b800f7',
                        backgroundImage: "url('images/strawberry-juice-image.png')", backgroundPosition: 'top', backgroundSize: 'cover', backgroundRepeat: 'no-repeat'
                    }}>

                    

                    </div>
                    <div style={{
                        height: 100,
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                        width: 100,
                        transform: 'scaleX(-1)',
                        backgroundColor: '#b800f7',
                        backgroundImage: "url('images/strawberry-juice-image.png')", backgroundPosition: 'top', backgroundSize: 'cover', backgroundRepeat: 'no-repeat'
                    }}></div>
                    <div style={{ textAlign: 'left', display: 'flex', flexDirection: 'column' }}> {[{ label: "Contact Us", link: '/contact-us' }].map(footerItem => <Link style={{ textDecoration: 'none', color: 'inherit' }} to={footerItem.link}>{footerItem.label}</Link>)}</div>
                    {/* <div style={{ textAlign: 'left', display: 'flex', flexDirection: 'column' }}> {[{ label: "Privacy Policy", link: '/privacy-policy' }, { label: "Terms and Conditions", link: '/terms-and-conditions' }].map(footerItem => <Link style={{ textDecoration: 'none', color: 'inherit' }} to={footerItem.link}>{footerItem.label}</Link>)}</div>
              */}   </div>


               <div style={{textAlign:'center', display:'flex', width:200, padding:10, justifyContent:'space-around', fontSize:11}}>
                    <a href='https://www.facebook.com/share/1azggdrZiX/?mibextid=wwXIfr'><img width={24} src={'/social/facebook.svg'}/></a>
                    <a href='https://www.instagram.com/china_enye?igsh=MW15cmFxODlqdHB6bw%3D%3D&utm_source=qr'><img width={24} src={'/social/instagram.svg'}/></a>
                    <a href='https://wa.me/+2347036462295'><img width={24} src={'/social/whatsapp.svg'}/></a>
                    <a href='tel:+2347036462295'><img width={24} src={'/social/phone.svg'}/></a>
                    <a href='mailto:Korafresh21@gmail.com'><img width={24} src={'/social/email.svg'}/></a>
                </div>
                {/* <div style={{ textAlign: 'center', fontSize: 12, padding: 10 }}>info@odanow.net</div> */}
                <div style={{ textAlign: 'center', fontSize: 11 }}>© Copyright KoraFresh {(new Date).getFullYear()}</div>
            </div>
        </div>
        {/*</NotificationsWrapper>*/}

    </SideMenuContext>)
}

export default LayoutWrapper;


